import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../routes'
import { pages } from '../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { FormLoader } from '../../components/Loader/FormLoader'
import PagesContent from '../../components/Dashboard/PagesContent'
import { LanguageConsumer } from '../../LanguageContext'


const Pages = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.Pages' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={pages.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.Pages' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<LanguageConsumer>
                  {({ locale }) => (
                    <PagesContent handleNotificationCall={handleNotificationCall}
                                  adminSectionType={adminSectionType}
                                  locale={locale}/>
                  )}
                </LanguageConsumer>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Pages

